//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  system,
  getUserInfo,
  isApp,
  shareFun,
  toggleTopbar,
  switchNavColor,
  callApp,
  controlTopButton,
  logEventStatistics,
  pageViewStatistics
} from '@/util/const'
import {setAuthorization} from '@/axios/userInfo'
import axios from 'axios'

export default {
  name: 'simple',
  computed: {
    classObject() {
      if (this.tabIndex === 0) {
        this.word = this.$t('everyDaySpecial.w1')
      } else if (this.tabIndex === 1) {
        this.word = this.$t('everyDaySpecial.w2')
      } else if (this.tabIndex === 2) {
        this.word = this.$t('everyDaySpecial.w3')
      } else if (this.tabIndex === 3) {
        this.word = this.$t('everyDaySpecial.w4')
      } else if (this.tabIndex === 4) {
        this.word = this.$t('everyDaySpecial.w5')
      }
      return {
        'isApp': !this.ISApp,
        'bg1 cny1': this.tabIndex === 0,
        'bg2 cny2': this.tabIndex === 1,
        'bg3 cny3': this.tabIndex === 2,
        'bg4 cny4': this.tabIndex === 3,
        'bg5 cny5': this.tabIndex === 4,
      }
    }
  },
  data() {
    return {
      lang: null,
      tabList: [
        {
          curDay: 1,
          today: this.$t('everyDaySpecial.today'),
          future: this.$t('everyDaySpecial.c2'),
          now: this.$t('everyDaySpecial.c1'),
          end: this.$t('everyDaySpecial.c3'),
          day: this.$t('everyDaySpecial.one'),
        },
        {
          curDay: 2,
          today: this.$t('everyDaySpecial.today'),
          future: this.$t('everyDaySpecial.c2'),
          now: this.$t('everyDaySpecial.c1'),
          end: this.$t('everyDaySpecial.c3'),
          day: this.$t('everyDaySpecial.two'),
        },
        {
          curDay: 3,
          today: this.$t('everyDaySpecial.today'),
          future: this.$t('everyDaySpecial.c2'),
          now: this.$t('everyDaySpecial.c1'),
          end: this.$t('everyDaySpecial.c3'),
          day: this.$t('everyDaySpecial.three'),
        },
        {
          curDay: 4,
          today: this.$t('everyDaySpecial.today'),
          future: this.$t('everyDaySpecial.c2'),
          now: this.$t('everyDaySpecial.c1'),
          end: this.$t('everyDaySpecial.c3'),
          day: this.$t('everyDaySpecial.four'),
        },
        {
          curDay: 5,
          today: this.$t('everyDaySpecial.today'),
          future: this.$t('everyDaySpecial.c2'),
          now: this.$t('everyDaySpecial.c1'),
          end: this.$t('everyDaySpecial.c3'),
          day: this.$t('everyDaySpecial.five'),
        }
      ],
      tabIndex: 0,
      list: [],
      data: null,
      timer: null,
      time: null,
      H: null,
      M: null,
      S: null,
      flag: 0,
      ISApp: true,
      bg: '',
      word: '',
      today: null,
    }
  },
  methods: {
    // tab切换方法
    tabCheck(item, index, flag = false) {
      if (this.tabIndex === index && flag === false) return
      this.tabIndex = index
      this.getList(item.curDay)
    },
    // 倒计时计算
    timerFnc() {
      let that = this

      function T() {
        let curTimestamp = new Date().getTime()
        let timestamp = new Date((that.time.replace(/-/g, '/'))).getTime()
        let time = parseInt(((timestamp - curTimestamp) / 1000))
        let d = parseInt(time / 3600 / 24)
        let h = parseInt((time / 3600) % 24)
        let m = parseInt((time / 60) % 60) < 10 ? '0' + parseInt((time / 60) % 60) : parseInt((time / 60) % 60)
        let s = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
        that.H = (h + d * 24) < 10 ? '0' + (h + d * 24) : (h + d * 24)
        that.M = m
        that.S = s
      }

      T()
      this.timer = setInterval(() => {
        T()
      }, 1000)
    },
    // 商品点击跳转
    goWhere(item) {
      logEventStatistics({
        umkey: 'daily_special_offer_product',
        param: 'goodsId',
        value: item.goodsId,
      })
      /*
        type = 1 走积分商城 照旧
        type = 2 照旧
        type = 3 5G升级  按钮显示去升级
        type = 4 eshop隐藏页面跳转  按钮显示去购买
        type = 5 充值缴费券 按钮显示 立即领取
      * */
      if (this.ISApp === false) {
        callApp(`${window.location.origin}/activity/mylinkActivity/#/everyDaySpecial/simpel?hideNavigationBar=true`)
        return;
      }
      let time = ''
      if (this.tabIndex + 1 !== this.today || this.flag === 1) time = `&curStartTime=${this.data.begin}`
      let url = `${window.location.origin}/mylink`
      if (item.type === 1) {
        window.location.href = `${url}/#/integral/goodsDetail?goodsId=${item.goodsId}&type=${item.type}&close=2${time}`
      } else if (item.type === 2 || item.type === 5 || item.type === 6) {
        window.location.href = `${url}/#/integral/goodsDetailMer?goodsId=${item.goodsId}&type=${item.type}&close=2${time}`
      } else if (item.type === 3 || item.type === 4) {
        window.location.href = `${url}/#/integral/goodsDetail?goodsId=${item.goodsId}&type=${item.type}&redirectUrl=${encodeURIComponent(item.redirectUrl)}&close=2${time}`
      }
    },
    // 看今日
    lookToday() {
      this.tabCheck(this.tabList[this.today - 1], this.today - 1)
    },
    // 头部
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      window.localStorage.scrollTop = scrollTop
      if (scrollTop > 60) {
        toggleTopbar(1)
        switchNavColor({color: '333333'})
        document.title = this.data.actName
      } else {
        switchNavColor({color: 'FFFFFF'})
        toggleTopbar(0)
        document.title = this.$t('everyDaySpecial.title')
      }
    },
    // 标签转换
    tagSet(tag) {
      if (tag === '0') {
        return this.$t('everyDaySpecial.c11')
      } else {
        let reg = /OFF/g
        let reg1 = /\d/
        if (reg.test(tag)) {
          return tag
        } else {
          if (!reg1.test(tag)) {
            return tag
          } else {
            let str = tag.substr(0, 1)
            return (this.lang !== 'en' ? str + '折' : (10 - parseInt(str)) * 10 + '% OFF')
          }
        }

      }
    },
    // 获取数据
    getList(day) {
      this.data = null
      this.list = []
      this.H = null
      this.M = null
      this.S = null
      clearInterval(this.timer)
      this.timer = null
      this.$http.get('/v1/api/business_alliance/redeem/coupon/activity', {weekDay: day}).then(res => {
        if (res.data.header.resultCode === 0) {
          let data = res.data.body.result[0]
          this.data = res.data.body.result[0]
          this.list = data.coupons
          if (data.begin) {
            this.flag = 1
            this.time = data.begin
          } else {
            this.flag = 0
            this.time = data.end
          }
          this.timerFnc()
        }
      })
    },
    // 初始化
    init() {
      this.$http.get('/v1/api/business_alliance/redeem/coupon/activity', {weekDay: 1}).then(res => {
        if (res.data.header.resultCode === 0) {
          let data = res.data.body.result[0]
          // 获取今天是周几
          let now = new Date(data.currentTime);
          let day = now.getDay() === 0 ? 7 : now.getDay()
          this.today = (day === 6 || day === 7 ? day = 5 : day)
          this.tabIndex = day - 1
          if (day === 5) this.tabIndex = 4
          if (this.$route.query.weekDay) {
            this.tabCheck(this.tabList[this.$route.query.weekDay - 1], this.$route.query.weekDay - 1, true)
          } else {
            this.tabCheck(this.tabList[this.tabIndex], this.tabIndex, true)
          }
          // 显示客户端分享按钮
          shareFun({
            type: 1,
            url: `${window.location.origin}/activity/mylinkActivity/#/everyDaySpecial/simple?hideNavigationBar=true&weekDay=${this.today}`,
            title: this.$t('everyDaySpecial.shareTitle'),
            content: this.$t('everyDaySpecial.shareTitle'),
            img: require('../../../static/img/new_ml_logo_a@2x.png'),
          })
        }
      })
    },
    jumpURL() {
      window.location.href = `https://mylink.komect.com/activity/via/earn-points/index.html?lang=${this.lang}`
    }
  },
  destroyed() {
    // 页面离开统计
    pageViewStatistics({
      pageId: 'daily_special_offer_page',
      start: 0
    })
    clearInterval(this.timer)
    this.timer = null
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  activated() {
    window.scrollTo(0, window.localStorage.scrollTop ? parseInt(localStorage.scrollTop) : 0);
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  created() {
    if (!isApp()) this.ISApp = false
    window.getUserInfo = (obj) => {
      if (obj) {
        setAuthorization(obj.authorization)
      }
      if (!isApp() || system() === 'unknown') {

      } else {
        getUserInfo({callbackName: 'getUserInfo', needLogin: false})
      }
    }
    this.lang = window.localStorage.lang
    // 控制返回按钮
    /*         controlTopButton({
                 backVisible: true,
                 left1icon: 'new_navi_back',
                 left1link: 'cmcchkh5action://close',
             });*/
    // 页面进入统计
    pageViewStatistics({
      pageId: 'daily_special_offer_page',
      start: 1
    })
    // 隐藏客户端状态栏
    toggleTopbar(0);
    // h5控制客户端导航栏字体颜色
    switchNavColor({color: 'FFFFFF'})
    // 初始化
    this.init()
  },
}



// WEBPACK FOOTER //
// ./src/page/everyDaySpecial/simple.vue